import styled from 'styled-components';

export const StyledTabs = styled.div`
  display: flex;
`;

export const StyledTab = styled.button<{
  selected?: boolean;
  hover: boolean;
  disabled?: boolean;
}>`
  cursor: pointer;
  width: unset;
  border: none;
  height: 47px;
  padding: 14px 24px 14px 24px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.white};
  border-bottom: solid 4px
    ${({ selected, theme }) =>
      selected ? theme.palette.tomato : theme.palette.white};
`;

export const TabText = styled.span<{ isSelected?: boolean }>`
  padding-left: 5px;
  & span {
    white-space: nowrap;
    color: ${({ theme }) => theme.palette.D400} !important;
    font-weight: 600 !important;
    font-size: 18px !important;
  }
`;
